(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Mojo-instagram"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('[data-mojo-ig]:not([data-mojo-ig-init])');
  if (!sections.length) return;

  sections.forEach(function (sec) {
    sec.setAttribute('data-mojo-ig-init', '1');

    if (!('IntersectionObserver' in window)) {
      sec.classList.add('is-visible');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          sec.classList.add('is-visible');
          io.disconnect();
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

    io.observe(sec);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Mojo-where"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-mojo-where]');
  if (!root) return;

  var panels = root.querySelectorAll('[data-where-panel]');

  function closeOthers(current) {
    panels.forEach(function (p) {
      if (p !== current && p.open) p.open = false;
    });
  }

  panels.forEach(function (p) {
    p.addEventListener('toggle', function () {
      if (p.open) closeOthers(p);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojo-cart-drawer"]) return;
  try {
    
(function () {
  if (window.__mojoCartDrawerInit) return;
  window.__mojoCartDrawerInit = true;

  function getDrawer() {
    return document.querySelector('[data-mojo-cart-drawer]');
  }

  function open() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function setLoading(state) {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.toggle('is-loading', !!state);
  }

  /* Refresh the drawer's inner content via section rendering API */
  function refreshDrawer() {
    return fetch('/?sections=mojo-cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['mojo-cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var newPanel = tmp.querySelector('.mojo-cart-drawer__panel');
        var drawer = getDrawer();
        var currentPanel = drawer && drawer.querySelector('.mojo-cart-drawer__panel');
        if (newPanel && currentPanel) {
          currentPanel.innerHTML = newPanel.innerHTML;
        }
        return updateCartCount();
      })
      .catch(function (err) { console.error('Mojo cart refresh failed:', err); });
  }

  /* Sync the header cart count badge */
  function updateCartCount() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-mojo-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      })
      .catch(function (err) { console.error('Mojo count update failed:', err); });
  }

  /* GLOBAL CLICK DELEGATION */
  document.addEventListener('click', function (e) {
    /* Open drawer */
    var opener = e.target.closest('[data-mojo-cart-open]');
    if (opener) {
      e.preventDefault();
      open();
      return;
    }

    /* Close drawer */
    var closer = e.target.closest('[data-mojo-cart-close]');
    if (closer) {
      /* Only block default if it's a button or overlay (not a link going somewhere) */
      if (closer.tagName === 'BUTTON' || closer.classList.contains('mojo-cart-drawer__overlay')) {
        e.preventDefault();
      }
      close();
      return;
    }
  });

  /* ESCAPE to close */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var drawer = getDrawer();
      if (drawer && drawer.classList.contains('is-open')) close();
    }
  });

  /* INTERCEPT ADD-TO-CART FORMS */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    e.preventDefault();

    var button = form.querySelector('[type="submit"]');
    if (button) {
      button.dataset._mojoLabel = button.innerHTML;
      button.disabled = true;
    }

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () { return refreshDrawer(); })
      .then(function () { open(); })
      .catch(function (err) {
        console.error('Mojo add-to-cart failed:', err);
        alert(err && err.description ? err.description : 'Could not add to cart.');
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          if (button.dataset._mojoLabel) {
            button.innerHTML = button.dataset._mojoLabel;
            delete button.dataset._mojoLabel;
          }
        }
      });
  });

  /* QUANTITY + REMOVE controls inside drawer */
  document.addEventListener('click', function (e) {
    var inc = e.target.closest('[data-mojo-qty-inc]');
    var dec = e.target.closest('[data-mojo-qty-dec]');
    var rem = e.target.closest('[data-mojo-qty-remove]');
    if (!inc && !dec && !rem) return;

    var item = e.target.closest('[data-item-key]');
    if (!item) return;

    var key = item.getAttribute('data-item-key');
    var input = item.querySelector('[data-mojo-qty-input]');
    var current = parseInt(input ? input.value : '0', 10) || 0;
    var next = current;
    if (inc) next = current + 1;
    if (dec) next = Math.max(0, current - 1);
    if (rem) next = 0;

    setLoading(true);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: next })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshDrawer(); })
      .catch(function (err) { console.error('Mojo cart update failed:', err); })
      .finally(function () { setLoading(false); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojo-cart"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__mojoCartInit) return;
  window.__mojoCartInit = true;

  function getSection() { return document.querySelector('[data-mojo-cart]'); }

  function setLoading(state) {
    var s = getSection();
    if (s) s.classList.toggle('is-loading', !!state);
  }

  function refreshSection() {
    return fetch('/cart?sections=mojo-cart')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['mojo-cart'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var newInner = tmp.querySelector('.mojo-cart__inner');
        var s = getSection();
        var currentInner = s && s.querySelector('.mojo-cart__inner');
        if (newInner && currentInner) {
          currentInner.innerHTML = newInner.innerHTML;
        }
        /* Trigger drawer + header refresh too */
        document.dispatchEvent(new CustomEvent('cart:updated'));
      });
  }

  document.addEventListener('click', function (e) {
    var inc = e.target.closest('[data-mojo-cart-qty-inc]');
    var dec = e.target.closest('[data-mojo-cart-qty-dec]');
    var rem = e.target.closest('[data-mojo-cart-qty-remove]');
    if (!inc && !dec && !rem) return;

    var item = e.target.closest('[data-item-key]');
    if (!item || !item.closest('[data-mojo-cart]')) return;

    var key = item.getAttribute('data-item-key');
    var input = item.querySelector('[data-mojo-cart-qty-input]');
    var current = parseInt(input ? input.value : '0', 10) || 0;
    var next = current;
    if (inc) next = current + 1;
    if (dec) next = Math.max(0, current - 1);
    if (rem) next = 0;

    setLoading(true);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: next })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshSection(); })
      .catch(function (err) { console.error('Mojo cart update failed:', err); })
      .finally(function () { setLoading(false); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojo-flavours"] && !Shopify.designMode) return;
  try {
    
(function () {
  var buttons = document.querySelectorAll('[data-mojo-flavour-add]');
  if (!buttons.length) return;

  var toast = document.querySelector('[data-mojo-flavour-toast]');
  var toastText = document.querySelector('[data-mojo-flavour-toast-text]');
  var toastTimer;

  function showToast(msg) {
    if (!toast || !toastText) return;
    toastText.textContent = msg;
    toast.removeAttribute('hidden');
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.setAttribute('hidden', ''); }, 360);
    }, 2200);
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-mojo-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-count', cart.item_count);
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      })
      .catch(function () {});
  }

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var variantId = btn.getAttribute('data-variant-id');
      var name = btn.getAttribute('data-flavour-name') || 'mojo';
      if (!variantId) return;

      btn.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          btn.classList.remove('is-loading');
          if (res.ok) {
            btn.classList.add('is-added');
            showToast(name.toUpperCase() + ' ADDED :)');
            refreshCart();
            setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
          } else {
            showToast(res.data && res.data.description ? res.data.description : 'Could not add :(');
          }
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          showToast('Could not add. Please try again.');
        });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojo-header"]) return;
  try {
    
(function () {
  var headers = document.querySelectorAll('[data-mojo-header]:not([data-mojo-header-init])');
  if (!headers.length) return;

  headers.forEach(function (header) {
    header.setAttribute('data-mojo-header-init', '1');

    var sectionId = header.getAttribute('data-section-id');
    var toggle = header.querySelector('[data-mojo-menu-toggle]');
    var menu = document.getElementById('mojo-menu-' + sectionId);
    if (!toggle || !menu) return;

    /* ---- Move the menu to <body> so it escapes any parent containing block.
       Shopify section wrappers (and Blum's CSS) can apply transforms/filters that
       trap `position: fixed` inside their bounds. Moving to body fixes this. ---- */
    if (menu.parentNode !== document.body) {
      document.body.appendChild(menu);
    }

    var tabs = menu.querySelectorAll('[data-mojo-tab]');
    var panels = menu.querySelectorAll('[data-mojo-panel]');

    var lastFocus = null;
    var isOpen = false;

    /* ---- Header height CSS var (so body padding-top is correct) ---- */
    function updateHeaderHeight() {
      var h = header.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--mojo-header-height', h + 'px');
    }
    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight, { passive: true });
    if ('ResizeObserver' in window) {
      new ResizeObserver(updateHeaderHeight).observe(header);
    }

    /* ---- HIDE ON SCROLL DOWN, SHOW ON SCROLL UP ---- */
    var hideOnScroll = header.getAttribute('data-hide-on-scroll') === 'true';
    if (hideOnScroll) {
      var lastY = window.scrollY;
      var ticking = false;
      var threshold = 8;

      function handleScroll() {
        var y = window.scrollY;
        var headerH = header.getBoundingClientRect().height;

        // Always show near top of page.
        if (y < headerH) {
          header.classList.remove('is-hidden');
          lastY = y;
          ticking = false;
          return;
        }

        // Don't hide while menu open.
        if (isOpen) {
          ticking = false;
          return;
        }

        var diff = y - lastY;
        if (diff > threshold) {
          header.classList.add('is-hidden');
        } else if (diff < -threshold) {
          header.classList.remove('is-hidden');
        }

        lastY = y;
        ticking = false;
      }

      window.addEventListener('scroll', function () {
        if (!ticking) {
          requestAnimationFrame(handleScroll);
          ticking = true;
        }
      }, { passive: true });
    }

    /* ---- MENU OPEN/CLOSE ---- */
    function getFocusable() {
      return menu.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])');
    }

    function open() {
      if (isOpen) return;
      isOpen = true;
      lastFocus = document.activeElement;

      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close menu');
      document.body.classList.add('mojo-menu-open');
      header.classList.remove('is-hidden');

      requestAnimationFrame(function () {
        var f = getFocusable();
        if (f.length) f[0].focus();
      });
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;

      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open menu');
      document.body.classList.remove('mojo-menu-open');

      if (lastFocus) lastFocus.focus();
      else toggle.focus();
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      if (isOpen) close(); else open();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) close();
    });

    /* Focus trap */
    menu.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !isOpen) return;
      var f = getFocusable();
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    /* Close on link click inside menu */
    menu.querySelectorAll('a[href]').forEach(function (link) {
      link.addEventListener('click', function () {
        setTimeout(close, 80);
      });
    });

    /* ---- TAB SWITCHING ---- */
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-mojo-tab');

        tabs.forEach(function (t) {
          var active = t.getAttribute('data-mojo-tab') === target;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach(function (p) {
          var match = p.getAttribute('data-mojo-panel') === target;
          if (match) {
            p.removeAttribute('hidden');
            p.classList.add('is-active');
            // Restart card stagger animation: remove animations briefly, force reflow, then reapply.
            var cards = p.querySelectorAll('.mojo-menu__card');
            cards.forEach(function (c) { c.style.animation = 'none'; });
            void p.offsetWidth;
            cards.forEach(function (c) { c.style.animation = ''; });
          } else {
            p.setAttribute('hidden', '');
            p.classList.remove('is-active');
          }
        });
      });
    });

    /* ---- CART COUNT REFRESHER ---- */
    var cartCountEl = header.querySelector('[data-cart-count]');
    if (cartCountEl) {
      var refreshCart = function () {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var prev = parseInt(cartCountEl.textContent, 10) || 0;
            cartCountEl.textContent = cart.item_count;
            if (cart.item_count === 0) {
              cartCountEl.classList.add('is-empty');
            } else {
              cartCountEl.classList.remove('is-empty');
              if (cart.item_count > prev) {
                cartCountEl.classList.remove('is-bump');
                void cartCountEl.offsetWidth;
                cartCountEl.classList.add('is-bump');
              }
            }
          })
          .catch(function () {});
      };

      ['cart:updated', 'cart:refresh', 'cart:change', 'cart:item-added'].forEach(function (evt) {
        document.addEventListener(evt, refreshCart);
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojo-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var heroes = document.querySelectorAll('[data-mojo-hero]:not([data-mojo-hero-init])');
  if (!heroes.length) return;

  heroes.forEach(function (hero) {
    hero.setAttribute('data-mojo-hero-init', '1');

    var can = hero.querySelector('[data-mojo-can]');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Force-play any visible video. iOS Safari sometimes won't autoplay
    // on initial paint even with autoplay+muted+playsinline. Calling
    // .play() explicitly fixes it; falling back to first-touch if blocked.
    var videos = hero.querySelectorAll('.mojo-hero__video');
    videos.forEach(function (v) {
      // Only try the visible one — saves bandwidth on the off-screen video.
      if (window.getComputedStyle(v).display === 'none') return;
      v.muted = true;
      v.playsInline = true;
      var p = v.play();
      if (p && p.catch) {
        p.catch(function () {
          // Autoplay blocked — retry on first user gesture.
          var retry = function () {
            v.play().catch(function () {});
            document.removeEventListener('touchstart', retry);
            document.removeEventListener('click', retry);
          };
          document.addEventListener('touchstart', retry, { once: true, passive: true });
          document.addEventListener('click', retry, { once: true });
        });
      }
    });

    function ready() { hero.classList.add('is-ready'); }

    if (document.querySelector('[data-mojo-intro]')) {
      document.addEventListener('mojo:intro:done', ready, { once: true });
      setTimeout(ready, 3500);
    } else {
      requestAnimationFrame(ready);
    }

    if (!can || reduced) return;

    function runCan() {
      if (typeof window.gsap === 'undefined') {
        can.style.transform = 'rotate(-4deg)';
        return;
      }
      var gsap = window.gsap;
      gsap.set(can, { rotation: -4 });

      function loop() {
        var tl = gsap.timeline({ onComplete: loop });

        tl.to(can, { rotation: -1, duration: 1.8, ease: 'power2.inOut' })
          .to(can, { rotation: -5, duration: 1.3, ease: 'power2.inOut' })
          .to(can, { rotation: -3, duration: 2.1, ease: 'power2.inOut' });

        tl.to({}, { duration: 0.4 + Math.random() * 1.6 });

        var winkAngle = 22 + Math.random() * 10;
        var winkUp = -6 - Math.random() * 4;

        tl.to(can, { rotation: winkAngle, y: winkUp, duration: 0.38, ease: 'power3.out' })
          .to(can, { rotation: winkAngle - 1.5, duration: 0.55, ease: 'power1.inOut' })
          .to(can, { rotation: -4, y: 0, duration: 0.45, ease: 'power3.inOut' });

        tl.to({}, { duration: 1.2 + Math.random() * 1.0 });
      }

      loop();
    }

    if (typeof window.gsap !== 'undefined') {
      runCan();
    } else {
      var tries = 0;
      var poll = setInterval(function () {
        if (typeof window.gsap !== 'undefined' || tries++ > 30) {
          clearInterval(poll);
          runCan();
        }
      }, 60);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojo-impact"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.querySelector('[data-mojo-impact]');
  if (!section || section.dataset.mojoImpactInit) return;
  section.dataset.mojoImpactInit = '1';
/* ---- HERO VIDEO AUTOPLAY (iOS fix) ---- */
  var heroVideos = section.querySelectorAll('.mojo-impact__hero-video');
  heroVideos.forEach(function (v) {
    if (window.getComputedStyle(v).display === 'none') return;
    v.muted = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    var tryPlay = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    tryPlay();
    v.addEventListener('loadedmetadata', tryPlay, { once: true });
    v.addEventListener('canplay', tryPlay, { once: true });
    var unlock = function () { tryPlay(); ['touchstart','click','scroll'].forEach(function (e) { document.removeEventListener(e, unlock); }); };
    ['touchstart','click','scroll'].forEach(function (e) { document.addEventListener(e, unlock, { once: true, passive: true }); });
  });
  /* ---- TRAIL SCROLL PROGRESS ---- */
  var trail = section.querySelector('[data-mojo-trail]');
  if (trail) {
    var ticking = false;
    function updateTrail() {
      var rect = trail.getBoundingClientRect();
      var viewportH = window.innerHeight;
      var trailH = trail.offsetHeight;
      /* progress: 0 when top of trail at viewport bottom; 1 when bottom of trail at viewport top */
      var scrolled = viewportH - rect.top;
      var total = trailH + viewportH;
      var p = Math.max(0, Math.min(1, scrolled / total));
      trail.style.setProperty('--trail-progress', p.toFixed(3));
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(updateTrail); ticking = true; }
    }, { passive: true });
    window.addEventListener('resize', updateTrail, { passive: true });
    updateTrail();
  }

  /* ---- REVEAL ON SCROLL ---- */
  var reveals = section.querySelectorAll('[data-mojo-reveal]');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          /* Also flag parent step for node-pop animation */
          var step = entry.target.closest('.mojo-impact__step');
          if (step) step.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojo-lup-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  var grids = document.querySelectorAll('[data-mojo-lup-grid]:not([data-mojo-lup-grid-init])');
  grids.forEach(function (grid) {
    grid.setAttribute('data-mojo-lup-grid-init', '1');

    var baseBg = grid.style.getPropertyValue('--section-bg-base') || getComputedStyle(grid).backgroundColor;
    var cards = grid.querySelectorAll('[data-mojo-card]');
    var hoverTimeout = null;

    cards.forEach(function (card) {
      card.addEventListener('mouseenter', function () {
        var cardBg = card.getAttribute('data-card-bg');
        if (!cardBg) return;
        clearTimeout(hoverTimeout);
        grid.style.background = cardBg;
      });

      card.addEventListener('mouseleave', function () {
        clearTimeout(hoverTimeout);
        hoverTimeout = setTimeout(function () {
          grid.style.background = baseBg;
        }, 100);
      });
    });

    /* Mobile auto-pulse: every 3.5s, briefly tint section with next card's colour */
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isTouch = window.matchMedia('(hover: none)').matches;

    if (isTouch && !reduced && cards.length > 1) {
      var idx = 0;
      setInterval(function () {
        var card = cards[idx % cards.length];
        var bg = card.getAttribute('data-card-bg');
        if (bg) {
          grid.style.background = bg;
          setTimeout(function () { grid.style.background = baseBg; }, 900);
        }
        idx++;
      }, 3500);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojo-lup-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var heroes = document.querySelectorAll('[data-mojo-lup-hero]:not([data-mojo-lup-hero-init])');
  heroes.forEach(function (hero) {
    hero.setAttribute('data-mojo-lup-hero-init', '1');

    /* iOS autoplay force */
    var videos = hero.querySelectorAll('video');
    videos.forEach(function (v) {
      if (window.getComputedStyle(v).display === 'none') return;
      v.muted = true; v.playsInline = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
      var tryPlay = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      tryPlay();
      v.addEventListener('loadedmetadata', tryPlay, { once: true });
      v.addEventListener('canplay', tryPlay, { once: true });
      var unlock = function () { tryPlay(); ['touchstart','click','scroll'].forEach(function (e) { document.removeEventListener(e, unlock); }); };
      ['touchstart','click','scroll'].forEach(function (e) { document.addEventListener(e, unlock, { once: true, passive: true }); });
    });

    /* Scroll-fade — tracks how far user has scrolled past hero, sets CSS var */
    var media = hero.querySelector('.mojo-lup-hero__media');
    var content = hero.querySelector('.mojo-lup-hero__content');
    if (!media) return;

    var ticking = false;
    function updateProgress() {
      var rect = hero.getBoundingClientRect();
      var h = hero.offsetHeight;
      /* 0 when hero fully in view at top, 1 when hero fully scrolled out */
      var progress = Math.min(Math.max(-rect.top / h, 0), 1);
      media.style.setProperty('--scroll-progress', progress.toFixed(3));
      if (content) content.style.setProperty('--scroll-progress', progress.toFixed(3));
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(updateProgress); ticking = true; }
    }, { passive: true });
    updateProgress();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojo-lup-impact"] && !Shopify.designMode) return;
  try {
    
(function () {
  var impacts = document.querySelectorAll('[data-mojo-lup-impact]:not([data-mojo-lup-impact-init])');
  impacts.forEach(function (impact) {
    impact.setAttribute('data-mojo-lup-impact-init', '1');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { impact.classList.add('is-visible'); io.disconnect(); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
      io.observe(impact);
    } else {
      impact.classList.add('is-visible');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojo-lup-vibe"] && !Shopify.designMode) return;
  try {
    
(function () {
  var vibes = document.querySelectorAll('[data-mojo-lup-vibe]:not([data-mojo-lup-vibe-init])');
  vibes.forEach(function (vibe) {
    vibe.setAttribute('data-mojo-lup-vibe-init', '1');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { vibe.classList.add('is-visible'); io.disconnect(); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
      io.observe(vibe);
    } else {
      vibe.classList.add('is-visible');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojo-partner"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-mojo-partner]');
  if (!root || root.dataset.init) return;
  root.dataset.init = '1';

  var tabs = root.querySelectorAll('[data-mojo-tab]');
  var panels = root.querySelectorAll('[data-mojo-panel]');

  function activate(key) {
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-mojo-tab') === key;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    panels.forEach(function (p) {
      var on = p.getAttribute('data-mojo-panel') === key;
      p.classList.toggle('is-active', on);
      if (on) {
        p.removeAttribute('hidden');
      } else {
        p.setAttribute('hidden', '');
      }
    });
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      activate(tab.getAttribute('data-mojo-tab'));
    });
  });

  // If a form succeeded, open that tab
  var successPanel = null;
  panels.forEach(function (p) {
    if (p.querySelector('[data-mojo-success]')) successPanel = p;
  });
  if (successPanel) {
    activate(successPanel.getAttribute('data-mojo-panel'));
    successPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojo-pdp"] && !Shopify.designMode) return;
  try {
    
(function () {
  var pdps = document.querySelectorAll('[data-mojo-pdp]:not([data-mojo-pdp-init])');
  pdps.forEach(function (pdp) {
    pdp.setAttribute('data-mojo-pdp-init', '1');

    var mainCta = pdp.querySelector('[data-mojo-pdp-cta]');
    var sticky = pdp.querySelector('[data-mojo-pdp-sticky]');
    var stickyCta = pdp.querySelector('[data-mojo-pdp-sticky-cta]');
    var form = pdp.querySelector('[data-mojo-pdp-form]');

    /* ---- STICKY VISIBILITY ----
       Show sticky bar when main CTA is below the viewport. */
    if (mainCta && sticky && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          /* When the main CTA is NOT visible AND we've scrolled past it (below screen),
             show the sticky bar. */
          var rect = entry.target.getBoundingClientRect();
          var passedIt = rect.top < 0;
          if (!entry.isIntersecting && passedIt) {
            sticky.classList.add('is-visible');
          } else {
            sticky.classList.remove('is-visible');
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px 0px 0px' });
      io.observe(mainCta);
    }

    /* ---- STICKY CTA FORWARDS TO MAIN CTA ---- */
    if (stickyCta && form) {
      stickyCta.addEventListener('click', function () {
        if (stickyCta.hasAttribute('disabled')) return;
        /* Submit the form (lets the theme's cart drawer handler intercept). */
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojo-sponsor"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-mojo-sponsor]');
  if (!root || root.dataset.init) return;
  root.dataset.init = '1';

  var tabs = root.querySelectorAll('[data-mojo-tab]');
  var panels = root.querySelectorAll('[data-mojo-panel]');

  function activate(key) {
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-mojo-tab') === key;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    panels.forEach(function (p) {
      var on = p.getAttribute('data-mojo-panel') === key;
      p.classList.toggle('is-active', on);
      if (on) p.removeAttribute('hidden');
      else p.setAttribute('hidden', '');
    });
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      activate(tab.getAttribute('data-mojo-tab'));
    });
  });

  // If a form succeeded, jump to that tab
  var successEl = root.querySelector('[data-mojo-success]');
  if (successEl) {
    var key = successEl.getAttribute('data-success-tab');
    if (key) {
      activate(key);
      setTimeout(function () { successEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 100);
    }
  }

  // Custom Mojo-tone validation messages
  root.querySelectorAll('input, select, textarea').forEach(function (el) {
    el.addEventListener('invalid', function () {
      if (el.validity.valueMissing) el.setCustomValidity('oops, this one needs a little more.');
      else if (el.validity.typeMismatch) el.setCustomValidity('hmm, that format looks off.');
      else if (el.validity.rangeUnderflow) el.setCustomValidity('a bit too low.');
      else el.setCustomValidity('');
    });
    el.addEventListener('input', function () { el.setCustomValidity(''); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojo-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('[data-mojo-story]:not([data-mojo-story-init])');
  if (!sections.length) return;

  sections.forEach(function (sec) {
    sec.setAttribute('data-mojo-story-init', '1');

    if (!('IntersectionObserver' in window)) {
      sec.classList.add('is-visible');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          sec.classList.add('is-visible');
          io.disconnect();
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

    io.observe(sec);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojo-sustainability"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('[data-mojo-sustain]:not([data-mojo-sustain-init])');
  if (!sections.length) return;

  sections.forEach(function (sec) {
    sec.setAttribute('data-mojo-sustain-init', '1');

    if (!('IntersectionObserver' in window)) {
      sec.classList.add('is-visible');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          sec.classList.add('is-visible');
          io.disconnect();
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

    io.observe(sec);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojo-turning-heads"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-mojo-th]');
  if (!root || root.dataset.mojoThInit) return;
  root.dataset.mojoThInit = '1';

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ============================================================
     HERO — scroll-driven can rotation
     ============================================================ */
  var hero = root.querySelector('[data-mojo-th-hero]');
  var can = root.querySelector('[data-mojo-th-can]');
  var prompt = root.querySelector('[data-mojo-th-prompt]');
  var result = root.querySelector('[data-mojo-th-result]');

  if (hero && can && !reducedMotion) {
    var ticking = false;
    var lastProgress = -1;

    function updateHero() {
      var rect = hero.getBoundingClientRect();
      var heroHeight = hero.offsetHeight;
      var viewport = window.innerHeight;
      var scrollable = heroHeight - viewport; // runway
      var progress = 0;
      if (rect.top <= 0 && Math.abs(rect.top) <= scrollable) {
        progress = Math.abs(rect.top) / scrollable;
      } else if (rect.top < 0 && Math.abs(rect.top) > scrollable) {
        progress = 1;
      }
      progress = Math.max(0, Math.min(1, progress));

      if (progress === lastProgress) { ticking = false; return; }
      lastProgress = progress;

      /* Rotation: 0 → 90deg as user scrolls 0 → 1 */
      var rotate = progress * 90;
      /* Scale: slight zoom-out near the end so room for text */
      var scale = 1 - (progress * 0.18);
      /* Vertical: very slight downward drift */
      var ty = progress * -20;

      can.style.setProperty('--th-rotate', rotate.toFixed(2) + 'deg');
      can.style.setProperty('--th-scale', scale.toFixed(3));
      can.style.setProperty('--th-y', ty.toFixed(1) + 'px');

      /* Prompt fades out in first 25% */
      var promptOp = progress < 0.25 ? 1 - (progress / 0.25) : 0;
      if (prompt) prompt.style.setProperty('--th-prompt-op', promptOp.toFixed(2));

      /* Result fades in from 70% onwards */
      var resultOp = progress > 0.7 ? Math.min(1, (progress - 0.7) / 0.25) : 0;
      if (result) result.style.setProperty('--th-result-op', resultOp.toFixed(2));

      ticking = false;
    }

    function onScroll() {
      if (!ticking) { requestAnimationFrame(updateHero); ticking = true; }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', updateHero, { passive: true });
    updateHero();
  } else if (result) {
    /* reduced motion fallback: just show the result text */
    result.style.setProperty('--th-result-op', '1');
  }

  /* ============================================================
     REVEAL on scroll
     ============================================================ */
  var reveals = root.querySelectorAll('[data-mojo-reveal]');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ============================================================
     MODAL TABLETS — open/close via <dialog>
     ============================================================ */
  var openButtons = root.querySelectorAll('[data-mojo-th-open]');
  var closeButtons = root.querySelectorAll('[data-mojo-th-close]');
  var tablets = root.querySelectorAll('[data-mojo-th-tablet]');

  function openTablet(key) {
    var t = root.querySelector('[data-mojo-th-tablet="' + key + '"]');
    if (!t) return;
    if (typeof t.showModal === 'function') {
      t.showModal();
    } else {
      /* very old browser fallback */
      t.setAttribute('open', '');
      t.style.display = 'block';
    }
    document.body.style.overflow = 'hidden';
  }

  function closeTablet(t) {
    if (typeof t.close === 'function') {
      t.close();
    } else {
      t.removeAttribute('open');
      t.style.display = 'none';
    }
    document.body.style.overflow = '';
  }

  openButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.getAttribute('data-mojo-th-open');
      openTablet(key);
    });
  });

  closeButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var t = btn.closest('[data-mojo-th-tablet]');
      if (t) closeTablet(t);
    });
  });

  tablets.forEach(function (t) {
    /* close on backdrop click */
    t.addEventListener('click', function (e) {
      if (e.target === t) closeTablet(t);
    });
    /* restore body scroll on native close (e.g. ESC) */
    t.addEventListener('close', function () {
      document.body.style.overflow = '';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mojo-yerba"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.querySelector('[data-mojo-yerba]');
  if (!section || section.dataset.mojoYerbaInit) return;
  section.dataset.mojoYerbaInit = '1';

  /* ---- HERO VIDEO AUTOPLAY ---- */
  var heroVideos = section.querySelectorAll('.mojo-yerba__hero-video');
  heroVideos.forEach(function (v) {
    if (window.getComputedStyle(v).display === 'none') return;
    v.muted = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    var tryPlay = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    tryPlay();
    v.addEventListener('loadedmetadata', tryPlay, { once: true });
    v.addEventListener('canplay', tryPlay, { once: true });
    var unlock = function () { tryPlay(); ['touchstart','click','scroll'].forEach(function (e) { document.removeEventListener(e, unlock); }); };
    ['touchstart','click','scroll'].forEach(function (e) { document.addEventListener(e, unlock, { once: true, passive: true }); });
  });

  /* ---- REVEAL ON SCROLL ---- */
  var reveals = section.querySelectorAll('[data-mojo-reveal]');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
